module.exports = {
      id: "icon-social-vector-usage",
      viewBox: "0 0 17 13",
      url: __webpack_public_path__ + "../resources/views/web/layout/partials/svg-icons.blade.php#icon-social-vector",
      toString: function () {
        return this.url;
      }
    }